import { received } from "../constants/common";

/**
 * Who a referral was for, kept apart from where it was delivered (referral
 * routing items 6 and 7, client spec 2026-10-05).
 *
 * Reads the API's original_recipient / routed / organization_routes /
 * actioned_by. An older API sends none of them: every helper then returns
 * null, and the Referrals page looks exactly as it did before.
 */

/**
 * Sent tab: the clinician the sender picked, when routing delivered the
 * referral to the clinician's organization. The row's name / facility_name /
 * avatar are that organization's, so showing them would make it look as if
 * the referral had been sent to the organization.
 */
export const routedRecipient = (referral, tabId) =>
  tabId !== received && referral?.routed && referral?.original_recipient?.name
    ? referral.original_recipient
    : null;

/**
 * Received tab: who the referral is for. Every referral in the inbox of an
 * organization that routes centrally ("For Lakeside Counseling Group", "For
 * Taylor Brooks, L.P.C."), and any routed one: a routed referral is always
 * for its clinician.
 */
export const referralForName = (referral, tabId) => {
  const recipient = referral?.original_recipient;

  return tabId === received &&
    recipient?.name_with_credentials &&
    (referral.organization_routes || referral.routed)
    ? recipient.name_with_credentials
    : null;
};

/**
 * Sent tab, routed, once acted on: the organization is the actor, shown
 * under the clinician instead of in place of them. facility_name is the
 * organization's on a routed row, for referrals acted on before the API
 * recorded who acted.
 */
export const referralActionLine = (referral, tabId) => {
  if (!routedRecipient(referral, tabId)) return null;

  const organization = referral.actioned_by?.name || referral.facility_name;
  if (!organization) return null;

  if (referral.status === "accepted") return `Accepted by ${organization}`;
  if (referral.status === "rejected") return `Not accepted by ${organization}`;
  return null;
};

/**
 * Avatar for an organization row. facility_image is a bare file name; on the
 * Sent tab original_recipient carries the organization's full image URL when
 * it is who the sender picked.
 */
export const organizationImage = (referral, tabId) => {
  const recipient = referral?.original_recipient;

  return (
    (tabId !== received &&
      recipient?.type === "organization" &&
      recipient.profile_image) ||
    referral?.facility_image
  );
};
